/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerAccountsResponse as ModelsCustomerCustomerAccountsResponse } from '../../models/Models/Customer/customer-accounts-response';

export interface V3CustomersMeAccountsAccountNumberGet$Xml$Params {
  accountNumber: string;
}

export function v3CustomersMeAccountsAccountNumberGet$Xml(http: HttpClient, rootUrl: string, params: V3CustomersMeAccountsAccountNumberGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeAccountsAccountNumberGet$Xml.PATH, 'get');
  if (params) {
    rb.path('accountNumber', params.accountNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>;
    })
  );
}

v3CustomersMeAccountsAccountNumberGet$Xml.PATH = '/v3/customers/me/accounts/{accountNumber}';
